<div class="copo-section-header">
	<h2 mat-dialog-title class="copo-popup-title" translate>import.data</h2>
	<button type="button" mat-icon-button class="close-icon" [mat-dialog-close]="true"><mat-icon svgIcon="md:close"></mat-icon></button>
</div>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>import.file.message</span>
		</div>
		<div>
			- <span translate>import.file.message.all.fields.mandatory</span>
		</div>
	</div>
	<div class="copo-simple-dialog-content file-upload">
		<copo-file-upload class="file-upload" #attachmentDiv [fileErrors]="getErrorMsg()"
			[dragAndDropLabel]="('drag.and.drop.files' | translate)" [orLabel]="('upload.or' | translate)"
			[browseFilesLabel]="('browse.files' | translate)" (filesAdded)="addAttachments($event)">
		</copo-file-upload>
		<span class="inline-spinner" *ngIf="isReading">
			<copo-loading-spinner></copo-loading-spinner>
		</span>
	</div>

	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</mat-dialog-content>